function headersToObject (headers) {
  let promiseHeaders = {};
  for (var pair of headers.entries()) {
    promiseHeaders[pair[0]] = pair[1];
  }

  return promiseHeaders;
}

export default headersToObject;
